export default function Footer() {
  return (
    <footer className="bg-[#F5F5F0] relative">
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-[#FF6B6B] to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 py-12 md:py-16">
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
          <div>
            <span className="text-xl md:text-2xl font-bold text-[#0A1628]">Webloom</span>
            <p className="text-[#0A1628]/60 mt-3 md:mt-4 text-sm leading-relaxed">
              Professional websites for artisans, businesses and entrepreneurs
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-[#0A1628] mb-3 md:mb-4 text-sm md:text-base">Services</h4>
            <ul className="space-y-2 text-sm text-[#0A1628]/60">
              <li className="hover:text-[#FF6B6B] transition-colors cursor-pointer">Showcase website creation</li>
              <li className="hover:text-[#FF6B6B] transition-colors cursor-pointer">Website management</li>
              <li className="hover:text-[#FF6B6B] transition-colors cursor-pointer">Social media management</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-[#0A1628] mb-3 md:mb-4 text-sm md:text-base">Contact</h4>
            <a 
              href="mailto:hello@webloom-webstudio.com" 
              className="text-[#0A1628]/60 hover:text-[#FF6B6B] transition-colors text-sm break-all"
            >
              hello@webloom-webstudio.com
            </a>
            <p className="text-[#0A1628]/60 text-sm mt-2">Reply within 24h</p>
          </div>
        </div>

        <div className="pt-6 md:pt-8 border-t border-[#0A1628]/10 flex flex-col sm:flex-row items-center justify-between gap-3 md:gap-4">
          <div className="text-[#0A1628]/50 text-xs md:text-sm text-center sm:text-left">
            © 2025 Webloom Web Studio
          </div>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#0A1628]/40 hover:text-[#0A1628]/60 text-xs md:text-sm transition-colors"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
